import { useId } from "react";

/**
 * Логотип LightPay плиткой: синий скруглённый квадрат с молнией.
 * Геометрия молнии — ровно та же, что в /icons/light.svg (наш логотип),
 * только инвертированы цвета: там синяя молния на белом круге, здесь белая на синей плитке.
 */
const BOLT_PATH = "M73.5 14L34 74h23.5L49 114l45-62H69z";

const LightPayMark = ({ className = "w-16 h-16", title = "LightPay" }) => {
  // useId — иначе при двух экземплярах на странице дублируется id градиента.
  const gradientId = useId();
  return (
    <svg
      viewBox="0 0 128 128"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#3b88f7" />
          <stop offset="100%" stopColor="#1d5fd1" />
        </linearGradient>
      </defs>
      <rect width="128" height="128" rx="34" fill={`url(#${gradientId})`} />
      <path d={BOLT_PATH} fill="#ffffff" />
    </svg>
  );
};

export default LightPayMark;
